import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { getSectionNavMediumColor } from 'styles/helpers/getThemeStyles';
import { JoinDetailTypography } from 'bento-ordering/group_ordering/ui_components/GroupOrder';

const GroupOrderJoinDetail = ({ Icon, text, marginBottom = 0 }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
      mb={marginBottom}
    >
      <Box component="span" mr={0.75}>
        <Icon
          style={{
            width: '.75em',
            height: 'auto',
            display: 'block',
            margin: '0 auto',
            fill: getSectionNavMediumColor(theme)
          }}
        />
      </Box>
      <JoinDetailTypography>{text}</JoinDetailTypography>
    </Box>
  );
};

GroupOrderJoinDetail.propTypes = {
  Icon: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  marginBottom: PropTypes.number
};

export default GroupOrderJoinDetail;
